import { render, staticRenderFns, recyclableRender, components } from "./coupon-rewards.vue?vue&type=template&id=5920d726&scoped=true&"
var renderjs
import script from "./coupon-rewards.vue?vue&type=script&lang=js&"
export * from "./coupon-rewards.vue?vue&type=script&lang=js&"
import style0 from "./coupon-rewards.vue?vue&type=style&index=0&id=5920d726&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5920d726",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/coupon-rewards/coupon-rewards.vue"
export default component.exports